module.exports = flarum.reg.get('core', 'common/components/Tooltip');